import shopifyGenericDefaults from '../shopify-generic/config.js';

const wheelsFields = shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;
const tiresFields = shopifyGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;
const baseFields = shopifyGenericDefaults.fitmentSearch.baseFields;

export default {
  includes: ['shopify-generic'],
  ...shopifyGenericDefaults,
  SearchRequestDefaults: {
    ...shopifyGenericDefaults.SearchRequestDefaults,
    extra: {
      ...shopifyGenericDefaults.SearchRequestDefaults.extra,
      doNotHideWheelsTiresFacets: true,
    },
  },
  Widgets: [
    ...shopifyGenericDefaults.Widgets.filter(
      (w) => !['HomeVehicleWidget_tab', 'WheelPanel_tab', 'TirePanel_tab', 'SearchHeader'].includes(w.name),
    ),
    {
      name: 'SearchHeader',
      facetToggleConfig: {
        initToggled: true,
        toggledFacet: { field: 'Universal', term: 'True' },
        fieldsForVisibility: baseFields,
      },
    },
    {
      name: 'UniversalFacet',
      type: 'FacetToggle',
      initToggled: true,
      toggledFacet: { field: 'Universal', term: 'True' },
      fieldsForVisibility: baseFields,
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: '#cm-ymm-tab',
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 800,
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: '#cm-wheel-tab',
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: '/collections/method-wheels',
      selectFields: wheelsFields,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: '#cm-tire-tab',
      template: 'HomeWheelTireBar',
      redirectUrl: '/collections/atturo-tires',
      needInitRequest: true,
      selectFields: tiresFields,
    },
  ],
};
